<template>
    <div class="addMember">
      <el-form ref="form" label-width="80px">
        <el-form-item label="设备名称">
          <el-input v-model="memberInfoCopy.deviceName"></el-input>
        </el-form-item>
        <el-form-item label="设备型号">
          <el-input v-model="memberInfoCopy.deviceType"></el-input>
        </el-form-item>
        <el-form-item label="单路/双路">
          <el-cascader
              :options="routeList"
              v-model="memberInfoCopy.model"
              filterable
              :props="{value:'label'}"
              placeholder="单路/双路">
          </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addMemberFn">确定</el-button>
          <el-button @click="cancle">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
import {addDevice} from '@/api/api'
import bus from '@/bus'
import {testNull,testLength,testNumber} from '@/api/common'
export default {
  props:{
    memberInfo:{
      type:Object,
      required:false
    }
  },
  name: 'HelloWorld',
  data () {
    return {
      memberInfoCopy:{
        deviceName:'',
        deviceType:'',
        model:''
      },
      routeList:[{
          value:'单路',
          label:'单路'
        },
        {
            value:'双路',
            label:'双路'
        }]
    }
  },
  mounted(){

  },
  methods:{
    cancle(){
       bus.$emit('hidePop',false)
    },
    addMemberFn(){
      const {deviceName,deviceType,model} = this.memberInfoCopy
      let test=true
      test=testNull(this,deviceName,'设备名称')
      if(!test){return false}
      test=testNull(this,deviceType,'设备型号')
      if(!test){return false}
      test=testNull(this,model,'单路/双路')
      if(!test){return false}
      test=testLength(this,deviceName,30,'设备名称')
      if(!test){return false}
      test=testLength(this,deviceType,20,'设备型号')
      if(!test){return false}
      let data=JSON.stringify({
        deviceName,
        deviceType,
        'model':model[0]
      })
      addDevice(data).then(res=>{
        if(res.data.state==200){
          this.memberInfoCopy={}
          bus.$emit('closeEditMember')
          this.$message({
             message: '操作成功',
             type: 'success'
          })
        }else{
          this.$message({
             message:'操作失败',
             type: 'warning'
          })
        }
      })
    }
  },
  beforeRouteEnter(to,from,next) {
    var that=this
    var manager=localStorage.getItem('manager')
    if(manager=='M'){
      next()
    }else{
       alert('您没有访问权限')
       next('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .addCoctor {margin-left:20px;}
  .addCoctor li {height:50px;}
  .addDoctorItem {width:290px;height:30px;line-height: 30px;float: left;}
  .addDoctorItem span {width:120px;font-size:14px;text-align:right;float: left;}
  .addDoctorItem em {font-size:12px;margin-left:10px;}
  .addDoctorItem a {color:#357af1;}
  .addDoctorItem input[type=text] {color:#555;width:150px;height:30px;margin-left:5px;padding-left:10px;border:0;border-radius:4px;border:#ddd 1px solid;float: left;}
  .addDoctorItem input[type=number] {color:#555;width:150px;height:30px;margin-left:5px;padding-left:10px;border:0;border-radius:4px;border:#ddd 1px solid;float: left;}
  .addDoctorItem textarea {color:#555;width:300px;height:80px;line-height:22px;margin-left:5px;padding-left:10px;padding-top:10px;resize:none;border:#ddd 1px solid;border-radius:4px;}
  .addDoctorItem label {margin-right:30px;}
  .addDoctorItem input[type=radio] {margin-right:5px;position: relative;top:1px;}
  .addMember {width:350px;margin-left:40px;}
</style>



// WEBPACK FOOTER //
// src/components/EditType.vue